var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("v-data-table", {
        staticClass: "elevation-1 service-credentials",
        staticStyle: { width: "100%", "font-size": "12px" },
        attrs: {
          headers: _vm.headers,
          items: _vm.serviceCredentials,
          pagination: _vm.pagination,
        },
        on: {
          "update:pagination": function ($event) {
            _vm.pagination = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function (props) {
              return [
                _c(
                  "tr",
                  {
                    staticClass: "item-row",
                    class: {
                      new: _vm.newItems.includes(props.item.RefreshTokenId),
                    },
                  },
                  [
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.CreatedBy)),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.CreationDateUtc)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "center px-0" },
                      [
                        _c("ConfirmationDialog", {
                          attrs: {
                            loading: _vm.isRemoving(props.item),
                            small: true,
                            title: "Revoke Credential",
                            label: "Revoke",
                            text: "Are you sure you want to revoke this credential? All Camunda process that use this token must be updated.",
                          },
                          on: {
                            submit: function ($event) {
                              return _vm.remove(props.item)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            class: { hidden: !props.item.RefreshToken },
                            attrs: { small: "", dark: "" },
                            on: {
                              click: function ($event) {
                                return _vm.viewItem(props.item)
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { left: "" } }, [
                              _vm._v("search"),
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("Button.View")) +
                                "\n          "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("ViewItemDialog", {
        ref: "viewItemDialog",
        attrs: { serviceCredential: _vm.itemViewed },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }